import { MessageOperation, RequestOperation } from '@peercolab/engine'
import { SearchInput, TaskReminder } from '../../Core/PathItems'
import { AddPredefinedTaskSpeciesInput, UpdatePredefinedTaskSpeciesInput, RemovePredefinedTaskSpeciesInput } from '../../PathItems'
import { Published } from '../Core/PathItems'

export class CreatePredefinedTask extends RequestOperation<CreatePredefinedTaskInput,PredefinedTask> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.CreatePredefinedTask",
      "CREATE",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class SearchPredefinedTask extends RequestOperation<SearchInput,PredefinedTask[]> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.SearchPredefinedTask",
      "SEARCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class GetPredefinedTask extends RequestOperation<object,PredefinedTask> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.GetPredefinedTask",
      "GET",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class DeletePredefinedTask extends MessageOperation<object> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.DeletePredefinedTask",
      "DELETE",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskType extends MessageOperation<UpdatePredefinedTaskTypeInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskType",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskName extends MessageOperation<UpdatePredefinedTaskNameInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskName",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskIcon extends MessageOperation<UpdatePredefinedTaskIconInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskIcon",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskSuggestedRRULE extends MessageOperation<UpdatePredefinedTaskSuggestedRRULEInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSuggestedRRULE",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class AddPredefinedTaskSpecies extends MessageOperation<AddPredefinedTaskSpeciesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.AddPredefinedTaskSpecies",
      "ADD",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskSpecies extends MessageOperation<UpdatePredefinedTaskSpeciesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskSpecies",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class RemovePredefinedTaskSpecies extends MessageOperation<RemovePredefinedTaskSpeciesInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.RemovePredefinedTaskSpecies",
      "REMOVE",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export class UpdatePredefinedTaskState extends MessageOperation<UpdatePredefinedTaskStateInput> {
  constructor() {
    super(
      "PetKey.Main.Model.1_0_Initial.Backoffice.Tasks.UpdatePredefinedTaskState",
      "PATCH",
      ["PredefinedTaskId"],
      {
        requiresTenant: true,
        characterSetup: {
          performer: undefined,
          responsible: undefined,
          subject: undefined
        }
      }
    )
  }
}

export type CreatePredefinedTaskInput = {
  predefinedTaskId?: string | undefined
  name: string
  /**
   * Valid values: daily, health, longterm
   */
  type: string
}

export type PredefinedTask = {
  id: string
  species: Species[]
  /**
   * Valid values: daily, health, longterm
   */
  type: string
  name: string
  translationKey: string
  iconName?: string | undefined
  suggestedRRULE?: string | undefined
  suggestedReminders: TaskReminder[]
  state: Published
}

export type Species = {
  speciesId: string
  breedIds: string[]
}

export type UpdatePredefinedTaskTypeInput = {
  /**
   * Valid values: daily, health, longterm
   */
  type: string
}

export type UpdatePredefinedTaskNameInput = {
  name: string
}

export type UpdatePredefinedTaskIconInput = {
  icon?: string | undefined
}

export type UpdatePredefinedTaskSuggestedRRULEInput = {
  suggestedRRULE?: string | undefined
}

export type UpdatePredefinedTaskStateInput = {
  /**
   * Valid values: publish, unpublish, revert
   */
  stateTransition: string
}

